import { FC } from 'react';

import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

interface Props {
    name: string;
    area?: string;
}

const ResponsedVacancyName: FC<Props> = ({ name, area }) => {
    let fullNameString = name;
    if (area) {
        fullNameString += `${NON_BREAKING_SPACE}(${area})`;
    }

    return <span>{fullNameString}</span>;
};

export default ResponsedVacancyName;
